import {WidgetRepository} from "./widget.types";
import {NextthinkActionWidget} from "./nexthink/NextthinkAction.widget";
import {CreateIncidentActionWidget} from "./servicenow/CreateIncidentAction.widget";
import {LiveAgentChatActionWidget} from "./servicenow/LiveAgentChatAction.widget";
import {RequestCallbackActionWidget} from "./servicenow/RequestCallbackAction.widget";
import { SustainableItActionWidget } from "./nexthink/SustainableItAction.widget";
import { SmartSolutionWidget } from "./nexthink/SmartSolution.widget";
import { IntuneFixHomepageWidget } from "./intune/IntuneFixHomepage.widget";
import { TeamsActionWidget } from "./nexthink/TeamsAction.widget";

export const widgetRepository: WidgetRepository = {
    "nextthink_action": NextthinkActionWidget,
    "create_incident_widget": CreateIncidentActionWidget,
    "live_agent_chat_widget": LiveAgentChatActionWidget,
    "request_callback_widget": RequestCallbackActionWidget,
    "nexthink_sustainableit": SustainableItActionWidget,
    "nexthink_smartsolution": SmartSolutionWidget,
    "intune_fix_homepage": IntuneFixHomepageWidget,
    "teams_widget": TeamsActionWidget
}

export const findWidgetByKey = (values: any) => {
    const allWidgetKeys = Object.keys(widgetRepository);
    const valuesMeta = values?._meta?.widget || {};
    const name = valuesMeta?.name;
    console.log("Finding widget by key:", name);
    if (name && allWidgetKeys.includes(name)) {
        return widgetRepository[name as keyof WidgetRepository]
    }
  return null;
}
